import { Link } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { ArticleDto } from '../../news/application/dto/ArticleDto';
import './ArticlesPreview.css';

export interface ArticlesPreviewProps {
  heading: string;
  basePath: string;
  articles: ArticleDto[];
}

function formatDate(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('fa-IR');
}

/** Used for both the «اخبار» and «مقالات» homepage preview sections. */
export function ArticlesPreview({ heading, basePath, articles }: ArticlesPreviewProps) {
  return (
    <section className="dma-articles-preview" aria-labelledby={`dma-articles-preview-${basePath}`}>
      <Container>
        <h2 id={`dma-articles-preview-${basePath}`}>{heading}</h2>

        {articles.length === 0 ? (
          <p className="dma-articles-preview__empty">هنوز مطلبی در این بخش منتشر نشده است.</p>
        ) : (
          <div className="dma-articles-preview__grid">
            {articles.map((article) => (
              <Link key={article.id} to={`${basePath}/${article.slug}`} className="dma-articles-preview__card">
                {article.coverImage ? (
                  <img src={article.coverImage} alt={article.title} loading="lazy" />
                ) : (
                  <div className="dma-articles-preview__card-placeholder" aria-hidden="true" />
                )}
                <div className="dma-articles-preview__card-body">
                  {article.publishedAt ? <time dateTime={article.publishedAt}>{formatDate(article.publishedAt)}</time> : null}
                  <h3>{article.title}</h3>
                  <p>{article.summary}</p>
                </div>
              </Link>
            ))}
          </div>
        )}

        <Link to={basePath} className="dma-articles-preview__link">
          مشاهده همه {heading} ←
        </Link>
      </Container>
    </section>
  );
}
